import { render, staticRenderFns } from "./CompanySidebarContextMenu.vue?vue&type=template&id=391c62e2&"
import script from "./CompanySidebarContextMenu.vue?vue&type=script&lang=js&"
export * from "./CompanySidebarContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports